// extracted by mini-css-extract-plugin
export default {"BlueStyled":"Button_BlueStyled__PwmFP","PurpleStyled":"Button_PurpleStyled__6Nu7Y","Send":"Button_Send__SapE7"};